var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebookReferencePanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4H3C1.9 4 1 4.9 1 6V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V6C23 4.9 22.1 4 21 4ZM21 18C21 18.55 20.55 19 20 19H12V6H20C20.55 6 21 6.45 21 7V18ZM19.25 9.5H13.75C13.34 9.5 13 9.84 13 10.25C13 10.66 13.34 11 13.75 11H19.25C19.66 11 20 10.66 20 10.25C20 9.84 19.66 9.5 19.25 9.5ZM19.25 12H13.75C13.34 12 13 12.34 13 12.75C13 13.16 13.34 13.5 13.75 13.5H19.25C19.66 13.5 20 13.16 20 12.75C20 12.34 19.66 12 19.25 12ZM19.25 14.5H13.75C13.34 14.5 13 14.84 13 15.25C13 15.66 13.34 16 13.75 16H19.25C19.66 16 20 15.66 20 15.25C20 14.84 19.66 14.5 19.25 14.5Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookReferencePanel);
export default __webpack_public_path__ + "static/media/NotebookReferencePanel.884a9221b746c3329a74443c68a18caa.svg";
export { ForwardRef as ReactComponent };